import React, { useState, useEffect } from 'react';
import axios from 'axios';

function FloatingContact() {
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState({});

  useEffect(() => {
    axios.get('/api/settings').then(res => {
      if (res.data.settings) setSettings(res.data.settings);
    }).catch(() => {});
  }, []);

  const toggle = () => setOpen((prev) => !prev);

  const mainBtnStyle = {
    position: 'fixed',
    bottom: '24px',
    right: '24px',
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    background: '#0bb4aa',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '26px',
    boxShadow: '0 4px 16px rgba(11,180,170,0.4)',
    zIndex: 9999,
    transition: 'transform 0.3s ease, background 0.3s ease',
    transform: open ? 'rotate(45deg)' : 'rotate(0deg)',
  };

  const menuStyle = {
    position: 'fixed',
    bottom: '90px',
    right: '24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    zIndex: 9998,
    opacity: open ? 1 : 0,
    transform: open ? 'translateY(0) scale(1)' : 'translateY(16px) scale(0.85)',
    pointerEvents: open ? 'auto' : 'none',
    transition: 'opacity 0.3s ease, transform 0.3s ease',
  };

  const optionStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    textDecoration: 'none',
    background: '#1a1a1a',
    color: '#fff',
    padding: '10px 16px',
    borderRadius: '28px',
    fontSize: '14px',
    fontFamily: 'inherit',
    boxShadow: '0 2px 12px rgba(0,0,0,0.4)',
    whiteSpace: 'nowrap',
    transition: 'background 0.2s ease',
  };

  const iconCircleStyle = {
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    fontSize: '18px',
  };

  return (
    <>
      {/* Options menu */}
      <div style={menuStyle}>
        {/* Phone */}
        <a
          href={`tel:${(settings.phone || '063-782-4516').replace(/[^0-9+]/g, '')}`}
          style={optionStyle}
          onMouseEnter={(e) => (e.currentTarget.style.background = '#252525')}
          onMouseLeave={(e) => (e.currentTarget.style.background = '#1a1a1a')}
        >
          <span
            style={{
              ...iconCircleStyle,
              background: '#0bb4aa',
              color: '#fff',
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff">
              <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
            </svg>
          </span>
          <span>{settings.phone || '063-782-4516'}</span>
        </a>

        {/* Line */}
        <a
          href="https://line.me/ti/p/~kbyinteractive"
          target="_blank"
          rel="noopener noreferrer"
          style={optionStyle}
          onMouseEnter={(e) => (e.currentTarget.style.background = '#252525')}
          onMouseLeave={(e) => (e.currentTarget.style.background = '#1a1a1a')}
        >
          <span
            style={{
              ...iconCircleStyle,
              background: '#06C755',
              color: '#fff',
              fontWeight: 'bold',
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
              <path d="M12 2C6.48 2 2 5.79 2 10.36c0 3.35 2.67 6.26 6.6 7.33.26.06.6.18.69.42.08.21.05.55.03.76l-.11.67c-.03.21-.17.82.72.45.89-.38 4.81-2.83 6.56-4.85C18.36 13.13 22 11.53 22 10.36 22 5.79 17.52 2 12 2z" />
            </svg>
          </span>
          <span>Line @kbyinteractive</span>
        </a>

        {/* Facebook */}
        <a
          href={settings.facebook_url || "https://www.facebook.com/kbyinteractive"}
          target="_blank"
          rel="noopener noreferrer"
          style={optionStyle}
          onMouseEnter={(e) => (e.currentTarget.style.background = '#252525')}
          onMouseLeave={(e) => (e.currentTarget.style.background = '#1a1a1a')}
        >
          <span
            style={{
              ...iconCircleStyle,
              background: '#1877F2',
              color: '#fff',
              fontWeight: 'bold',
            }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#fff">
              <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 4.99 3.66 9.13 8.44 9.88v-6.99H7.9V12h2.54V9.8c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.77l-.44 2.89h-2.33v6.99C18.34 21.13 22 16.99 22 12z" />
            </svg>
          </span>
          <span>Facebook</span>
        </a>
      </div>

      {/* Main floating button */}
      <button
        onClick={toggle}
        style={mainBtnStyle}
        aria-label="Contact us"
        onMouseEnter={(e) => (e.currentTarget.style.transform = open ? 'rotate(45deg) scale(1.1)' : 'scale(1.1)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = open ? 'rotate(45deg)' : 'rotate(0deg)')}
      >
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </button>
    </>
  );
}

export default FloatingContact;
